import React from 'react';
import glamorous from 'glamorous';

import twitter from '../images/twitter.svg';
import linkedin from '../images/linkedin.svg';
import github from '../images/github.svg';
import { Container } from './Layout';

export default () => {
  return (
    <Footer>
      <Container>
        <Social>
          <a href="https://twitter.com/TFuqs">
            <img src={twitter} alt="Taylor Fuqua on Twitter" />
          </a>
          <a href="https://github.com/tfuqua">
            <img src={github} alt="Taylor Fuqua on Github" />
          </a>
          <a href="https://www.linkedin.com/in/taylorfuqua/">
            <img src={linkedin} alt="Taylor Fuqua on LinkedIn" />
          </a>
        </Social>

        <Copyright>
          <a href="/">
            Copyright © {new Date().getFullYear()} Taylor Fuqua
          </a>
        </Copyright>
      </Container>
    </Footer>
  );
};

const Footer = glamorous.div({
  background: '#1f3a56',
  padding: '16px 0',
  marginTop: '32px'
});

const Copyright = glamorous.div({
  padding: '32px 0 0',
  textAlign: 'center',
  fontWeight: '300',
  fontSize: '14px',

  '& a': {
    color: 'rgba(255, 255, 255, .7)',
    textDecoration: 'none'
  }
});

const Social = glamorous.div({
  textAlign: 'center',
  marginTop: '16px',
  '& a ': {
    display: 'inline-block',
    margin: '0 12px'
  },
  '& img': {
    color: '#fff',
    height: '36px',
    width: 'auto',
    verticalAlign: 'middle'
  }
});



// WEBPACK FOOTER //
// ./src/components/Footer.js